import React from 'react';
import { ForgeScreenEvent } from '@atlassian/jira-forge-ui-analytics/src/common/ui/index.tsx';
import { TriggerAnalyticsWrapper } from '@atlassian/jira-forge-ui-analytics/src/ui/personal-settings-page/index.tsx';
import { PERSONAL_SETTINGS_PAGE_MODULE } from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import type { PersonalSettingsPage } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { parseExtensionId } from '@atlassian/jira-forge-ui-utils-internal/src/utils/parse-extension-id/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { toSections } from '@atlassian/jira-navigation-apps-sidebar-forge/src/common/utils/subpages/index.tsx';
import { usePersonalSettingsForgeApps } from '@atlassian/jira-navigation-apps-sidebar-forge/src/controllers/personal-settings/index.tsx';
import type { MenuItemAnalyticsWithoutItemId } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/utils/get-analytics-attributes/types.tsx';
import { ForgeItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-forge/src/common/ui/forge-item/index.tsx';
import { getAppsPersonalSettingsPath } from '@atlassian/jira-personal-settings-paths/src/index.tsx';
import { MenuSection, MenuSectionHeading, MenuList } from '@atlassian/navigation-system';
import messages from './messages.tsx';

export const getItemHref = (extension: PersonalSettingsPage) => {
	const { appId, envId } = parseExtensionId(extension.id);
	return `${getAppsPersonalSettingsPath()}/${appId}/${envId}`;
};

type Props = {
	analytics: MenuItemAnalyticsWithoutItemId;
};

const BaseForgePersonalSettingsSection = ({ analytics }: Props) => {
	const { formatMessage } = useIntl();
	const { data: pages } = usePersonalSettingsForgeApps();

	if (!pages?.length) return null;

	return (
		<MenuSection>
			<MenuSectionHeading>{formatMessage(messages.heading)}</MenuSectionHeading>
			<MenuList>
				{pages.map((extension) => (
					<ForgeItem
						key={extension.id}
						id={extension.id}
						environmentType={extension.environmentType}
						environmentKey={extension.environmentKey}
						url={getItemHref(extension)}
						name={extension.properties.title}
						sections={toSections(extension)}
						iconUrl={extension.properties.icon}
						analytics={analytics}
						showIcon
					/>
				))}
			</MenuList>
			<ForgeScreenEvent
				attributes={{
					moduleType: PERSONAL_SETTINGS_PAGE_MODULE,
				}}
			/>
		</MenuSection>
	);
};
export const ForgePersonalSettingsSection = (props: Props) => (
	<TriggerAnalyticsWrapper>
		<BaseForgePersonalSettingsSection {...props} />
	</TriggerAnalyticsWrapper>
);
